import React from "react";
import { withRouter } from "react-router";
import { DATE_FORMAT, PAGE_MODE } from "../../../../../constants/constants";
import BarButtonFw, { BUTTON_DEFAULT, } from "../../../../../framework/bar-button/BarButtonFw";
import FormFw from "../../../../../framework/form/FormFw";
import GridFw, { COLUMN_DEFAULT } from '../../../../../framework/grid/GridFw';
import { MessageUtil } from '../../../../../util/MessageUtil';
import { Row, Col, Checkbox } from 'antd';

import { GastosOperativosModal } from "../modals/GastosOperativosModal";
import { UserUtil } from "../../../../../util/UserUtil";
import { BasePage } from "../../../../../framework/pages/BasePage";
import { LoadUtil } from '../../../../../framework/util/LoadUtil';
import { EnvConstants } from '../../../../../EnvConstants';
import { ReportUtil } from "../../../../../util/ReportUtil";
import { LoadingUtil } from "../../../../../util/LoadingUtil";
 
class GastosOperativosSection extends BasePage {
    renderPage(pageApi) {
    
    const cambiarTabPanel = pageApi.cambiarTabPanel; 
 
    
    const fnDelete_GastOpe = (value, row, index) => {
      getGrid_GastOpe().deleteItem(row.key);      
    }

    const getFormPrincipal = () => pageApi.getComponent('form');
    const getGrid_GastOpe = () => pageApi.getComponent('GastosOperativosSection');
    const getForm_GastOpe = () => pageApi.getComponent('formGO');
    const getFormResumen = () => pageApi.getComponent('formResumen');
    const getGridResumen = () => pageApi.getComponent('ResumenSection');

    const gastoOperativoConfig = {
        events: {
            afterAddEvent : (data) => {
                let datos_grid = getGrid_GastOpe().getData();
                let find_data = datos_grid.find(x => x.id_gasto_operativo == data.id_gasto_operativo && x.descripcion_grupo == data.descripcion_grupo)

                if(find_data) return MessageUtil('warning','Alerta!','Ya Seleccionó el Gasto Operativo con el mismo Grupo'); 
                getGrid_GastOpe().addItem({
                    ...data,
                    tipoClienteDes: 'Inspectorate',
                    id_tipo_cliente: 1
                });
                getGrid_GastOpe().refresh();

                return MessageUtil('success','Gasto Operativo agregado correctamente!','');
            }
        }
    }

    const gastoOperativoModalConfig = (data) =>{
        return {
            width: 950,
            maskClosable: false,
            component: <GastosOperativosModal name={data} getParentApi={pageApi.getApi} config={gastoOperativoConfig} />
        }
    };

    const barHeaderConfig = {
        fields:[
            {...BUTTON_DEFAULT.SEARCH, label:'Agregar', onClick: ()=>{ 
                    pageApi.showModal(gastoOperativoModalConfig(getFormPrincipal()));  
            }},
        ]
    }

  const calculateTotal = () => {
        let items = getGrid_GastOpe().getData();
        if (items){
            let total = 0;
            let vuelta_moneda = 0; 
            let simb_moneda = "";

            items.forEach(item => {
                total = total + parseFloat(item.sub_total); 

            if(vuelta_moneda == 0){ 
                simb_moneda = item.simb_moneda 
                vuelta_moneda = 1; 
            } 


            });
            let total_go = parseFloat(total);
            getForm_GastOpe().setFieldData('sub_total_go',simb_moneda + ' ' + total_go.toFixed(2));

            let data_resumen = getGridResumen()?.getData()?.map( (x ,i) => {
                if(i == 1){
                    x.costo_servicio = total_go;
                    if(x.porcentaje == 0){
                        x.servicio_con_descuento = parseFloat(x.costo_servicio).toFixed(2);   
                    }
                    else{
                        x.descuento = (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje) / 100);
                        x.servicio_con_descuento = parseFloat(x.costo_servicio) - (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje) / 100);
                    }
                    getFormResumen().setFieldData('gasto_operativo', isNaN(parseFloat(x.servicio_con_descuento)) ? '0.00' : parseFloat(x.servicio_con_descuento).toFixed(2));
                }
                return x;
            })
            getGridResumen()?.setData(data_resumen);


            let data_resumen_total = getGridResumen()?.getData()?.map( (x ,i) => {
                let total_resumen = parseFloat(getGridResumen()?.getData()[0].servicio_con_descuento) + parseFloat(getGridResumen()?.getData()[1].servicio_con_descuento);
                if(i == 2){
                    x.costo_servicio = parseFloat(total_resumen).toFixed(2);
                    if(x.porcentaje == 0){
                        x.servicio_con_descuento = parseFloat(x.costo_servicio).toFixed(2);  
                    }
                    else{
                        x.descuento = (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje) / 100);
                        x.servicio_con_descuento = parseFloat(x.costo_servicio) - (parseFloat(x.costo_servicio) * parseFloat(x.porcentaje) / 100);
                    }
                    getFormResumen().setFieldData('total_neto', isNaN(parseFloat(x.servicio_con_descuento)) ? '0.00' : parseFloat(x.servicio_con_descuento).toFixed(2));
                    let total_servicio = parseFloat(parseFloat(x.servicio_con_descuento) * 1.18);
                    getFormResumen().setFieldData('igv', isNaN(parseFloat(parseFloat(x.servicio_con_descuento) * 0.18)) ? '0.00' : parseFloat(parseFloat(x.servicio_con_descuento) * 0.18).toFixed(2));
                    getFormResumen().setFieldData('total_servicio', isNaN(total_servicio) ? 0 : total_servicio.toFixed(2));
                }
                return x;
            })
            getGridResumen()?.setData(data_resumen_total);
        }
    }
 
    const gridConfig_GastosOpe = {
            title: 'Gastos Operativos',
            rowId: 'id_rel_cot_go',
            showIndex: true,
            pagination: true,
            autoLoad: true, 
            collapsible: true,
            load: {
                validation: () => pageApi.getParamId()!=null, //solo se dispara si el valor es distinto de nulo
                queryId: 189,
                params: {id_doc: pageApi.getParamId()},
                hideMessage: true, 
                hideMessageError: true,
                fnOk: (resp) => {
                    calculateTotal();
                }
            },
            save: {
                queryId: 188,
                hideMessage: true, 
                hideMessageError: true,
                fnOk: (resp) => {
                    calculateTotal();
                    const id_doc = resp.dataObject?.id_doc;  
                    const est_tab_actual = resp.dataObject?.est_tab;    
                    const doc_nro = resp.dataObject?.doc_nro;

                    let url = EnvConstants.GET_REPORT2_URL() + 'CotizacionMa';     
                    ReportUtil.donwloadFromPost(url, {queryId: 858, params: {id_doc: pageApi.getParamId()}},
                    "Cotizacion_Pendiente_"+ doc_nro +".pdf").then(x => {
                        LoadingUtil.loadHide();
                        
                        if(est_tab_actual == 5){
                            this.props.history.push(`/cotizaciones/cotizaciones/5/${id_doc}`)
                        }
            
                        this.props.cambiarTabPanel("5",pageApi.getParamId()); 
                            return MessageUtil(
                            "success",
                            "Exito!",
                            "Se ha habilitado Resumen de Compra"
                        ); 
                        
                    }).catch(x => {
                        console.error(x)
                        LoadingUtil.loadHide(); 
                    });
                }
            },
            addItem: {
                fnAfter: (row) => {
                    calculateTotal();
                }
            },
            updateItem: {
                fnAfter: (row) => {
                    calculateTotal();
                }
            },
            fields:[
                { name: 'descripcion_grupo', label: 'Descripcion', editable: true},
                { name: 'descripcion', label:'Item', editable: false},
                { type: 'select', name:'id_tipo_cliente', label:'Encargado', load: { queryId: 187 },  editable:true, labelName:'tipoClienteDes', require: true, value: 3, 
                    onChange: (value, values, formApi) => {
                        if(value === 2){
                            formApi?.setFieldData('precio_venta', '0.00');
                            formApi?.setFieldData('sub_total', '0.00');
                            getGrid_GastOpe().refresh();
                        }
                        else{
                            formApi?.setFieldData('precio_venta', parseFloat(values['precio_lista']));
                            
                            let cantidad_puntos = parseInt(values['cantidad_puntos']);
                            let dias =  parseInt(values['dias']);
                            let frecuencia = parseInt(values['frecuencia']);
                            let precio_venta = parseFloat(values['precio_lista']);
                            let sub_total = parseFloat(cantidad_puntos * frecuencia * precio_venta * dias).toFixed(2);


                            formApi?.setFieldData('sub_total', sub_total); 
                            getGrid_GastOpe().refresh();
                        } 
                    }
                },
 
                { name: 'frecuencia', label:'Frecuencia', editable: true, readOnly: true}, 
                {type: 'number', name: 'cantidad_puntos', label: 'Cantidad', editable:true,
                    onChange: (value, values, formApi) => {
                        let cantidad_puntos = parseInt(values['cantidad_puntos']);
                        let dias =  parseInt(values['dias']);
                        let frecuencia = parseInt(values['frecuencia']);
                        let precio_venta = parseFloat(values['precio_venta']);
                        let sub_total = parseFloat(cantidad_puntos * frecuencia * precio_venta * dias).toFixed(2);
                        
                        let precio_lista = parseFloat(values['precio_lista']);
    
                        formApi?.setFieldData('precio_lista', precio_lista.toFixed(2));
                        formApi?.setFieldData('precio_venta', precio_venta.toFixed(2));
                        formApi?.setFieldData('sub_total', sub_total);
                        
                        getGrid_GastOpe().refresh();
                    }
                },
                {type: 'number', name: 'dias', label:'Días', editable: true,
                    onChange: (value, values, formApi) => {
                        let cantidad_puntos = parseInt(values['cantidad_puntos']);
                        let dias =  parseInt(values['dias']);
                        let frecuencia = parseInt(values['frecuencia']);
                        let precio_venta = parseFloat(values['precio_venta']);
                        let sub_total = (cantidad_puntos * frecuencia * precio_venta * dias).toFixed(2);
    
                        let precio_lista = parseFloat(values['precio_lista']);
    
                        formApi?.setFieldData('precio_lista', precio_lista.toFixed(2));
                        formApi?.setFieldData('precio_venta', precio_venta.toFixed(2));
                        formApi?.setFieldData('sub_total', sub_total);
                        
                        getGrid_GastOpe().refresh();
                    }
                },
                // {type: 'number', name: 'frecuencia', label:'Frec.', editable: true,
                //     onChange: (value, values, formApi) => {
                //         let cantidad_puntos = parseInt(values['cantidad_puntos']);
                //         let dias =  parseInt(values['dias']);
                //         let frecuencia = parseInt(values['frecuencia']);
                //         let precio_venta = parseFloat(values['precio_venta']);
                //         let sub_total = (cantidad_puntos * frecuencia * precio_venta * dias).toFixed(2);
    
                //         let precio_lista = parseFloat(values['precio_lista']);
    
                //         formApi?.setFieldData('precio_lista', precio_lista.toFixed(2));
                //         formApi?.setFieldData('precio_venta', precio_venta.toFixed(2));
                //         formApi?.setFieldData('sub_total', sub_total);
                        
                //         getGrid_GastOpe().refresh();
                //     }
                // },
                // {type: 'hidden', name: 'precio_lista', label:'P. Lista', editable: false, readOnly: true ,display: 'none'},
                // {type: 'hidden', name: 'precio_venta', label:'Costo', editable: false,
                //     onChange: (value, values, formApi) => {
                //         let cantidad_puntos = parseInt(values['cantidad_puntos']);
                //         let dias =  parseInt(values['dias']);
                //         let frecuencia = parseInt(values['frecuencia']);
                //         let precio_venta = parseFloat(values['precio_venta']);
                //         let sub_total = (cantidad_puntos * frecuencia * precio_venta * dias).toFixed(2);
    
                //         let precio_lista = parseFloat(values['precio_lista']);
    
                //         formApi?.setFieldData('precio_lista', precio_lista.toFixed(2));
                //         formApi?.setFieldData('precio_venta', precio_venta.toFixed(2));
                //         formApi?.setFieldData('sub_total', sub_total);
                        
                //         getGrid_GastOpe().refresh();
                //     }
                // },
                // {type: 'hidden', name: 'sub_total', label:'Total', editable: false, readOnly: true},
                {...COLUMN_DEFAULT.DELETE, label:'Opciones', title: 'Eliminar', color: 'red', onClick: fnDelete_GastOpe}
            ],
            barHeader: barHeaderConfig
        };
    
        const form_go = {
            fields:[
                {  name:'sub_total_go', label: 'Sub Total',column: 12, readOnly: true}
            ],
        } 
    const barButtonFooter_GastosOpe = {
        fields: [
            { ...BUTTON_DEFAULT.RETURN, link: '/cotizaciones/cotizaciones-admin', alert: true, message: 'Está seguro de retornar?', },
            { ...BUTTON_DEFAULT.SAVE,label: 'Guardar y Continuar', onClick: async() => {
                 
                if(getGrid_GastOpe()?.getData().length > 0 ) {
                     getGrid_GastOpe()?.updateItem(getGrid_GastOpe()?.getData()[0]);
                     getGrid_GastOpe().save({ 
                     params: {
                        id_doc: pageApi.getParamId(),
                        id_user: UserUtil.getUserId(), 
                        sub_total: getForm_GastOpe()?.getData()?.sub_total_go,
                        est_tab : 5, 
                     }
                     })      
                }
                else {
                        LoadUtil.loadByQueryId({
                        url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                        queryId: 817,
                        //SE COLOCA ID_SS YA QUE ES UN REUTILIZABLE EN LA TABLA SE INSERA LA COTI Y LA SS
                        params: { id_SS: pageApi.getParamId(), est_tab : 5, id_user: UserUtil.getUserId(), id_doc: pageApi.getParamId() },
                        fnOk: (resp) => { 
                            const id_doc = resp.dataObject?.id_doc;  
                            const est_tab_actual = resp.dataObject?.est_tab;    
                            const doc_nro = resp.dataObject?.doc_nro;

                            let url = EnvConstants.GET_REPORT2_URL() + 'CotizacionMa';     
                            ReportUtil.donwloadFromPost(url, {queryId: 858, params: {id_doc: pageApi.getParamId()}},
                            "Cotizacion_Pendiente_"+ doc_nro +".pdf").then(x => {
                                LoadingUtil.loadHide();
                                
                                if(est_tab_actual == 5){
                                    this.props.history.push(`/cotizaciones/cotizaciones/5/${id_doc}`)
                                }
                    
                                this.props.cambiarTabPanel("5",pageApi.getParamId()); 
                                    return MessageUtil(
                                    "success",
                                    "Exito!",
                                    "Se ha habilitado Resumen de Compra"
                                ); 
                                
                            }).catch(x => {
                                console.error(x)
                                LoadingUtil.loadHide(); 
                            });
                        }
                        })  
                } 
            }
            },
        ]
    }


    return (
      <> 
        <BarButtonFw 
          name="barFooter"
          getParentApi={pageApi.getApi}
          config={barButtonFooter_GastosOpe} 
        />
        <GridFw
            name="GastosOperativosSection"
            getParentApi={pageApi.getApi}
            config={gridConfig_GastosOpe} 
        />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={8}>
            </Col>
            <Col className="gutter-row" span={8}>
            </Col>
            <Col className="gutter-row" span={8}>
            <FormFw
            name="formGO"
            getParentApi={pageApi.getApi}
            config={form_go}
            />
            </Col>
        </Row>
      </>
    ); 
}
}

export default GastosOperativosSection